import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import Link from './Link';
import { generateDatas } from './utils';

/**
 * MultiDataColumn
 * @param children {node}
 * @param data {array}
 * @param pop {bool}
 * @returns {JSX.Element}
 */
const MultiDataColumn = ({ children, data = [], pop = false }) => {
  const content = generateDatas(data);
  return (
    <>
      {pop && (
        <Popover
          content={
            <>
              {content}
              {children}
            </>
          }>
          {content}
          {children}
        </Popover>
      )}
      {!pop && (
        <>
          {content}
          {children}
        </>
      )}
    </>
  );
};

MultiDataColumn.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
  pop: PropTypes.bool
};

MultiDataColumn.Link = Link;

export default MultiDataColumn;
